import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "top-banner"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "banner-content" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "message-container" }

import FiltersComponent from '@/components/screens/Market/FiltersComponent.vue';
import MarketListComponent from '@/components/screens/Market/MarketListComponent.vue';
import DefaultLayout from '@/layouts/default/DefaultLayout.vue';
import { ref, onMounted } from 'vue';
import { fetchAndCombineFilters, lastSearch, lastNumFiltersApplied } from "@/services/frontend/FiltersService";
import { Filter } from "@/models/frontend/FeatureModels";
import {isTablet, isMobile} from "@/helpers/CommonHelper";
import BannerDesktop from '@/assets/images/Top-Banner-desktop_small.png';
import BannerTablet from '@/assets/images/Top-Banner-tablet_small.png';
import BannerMobile from '@/assets/images/Top-Banner-mobile_small.png';
import * as Session from "supertokens-web-js/recipe/session";


export default /*@__PURE__*/_defineComponent({
  __name: 'MarketPage',
  setup(__props) {

const filters = ref<Filter[]>([]);
const distance = ref<number>(0);
const appliedFilters = ref<Filter[]>([]);
const applyFiltersEvent = ref(0);
const numberFiltersApplied = ref<number>(0);
const isLoggedIn = ref<boolean>(false);

const applyFiltersHandler = () => {
  // Update appliedFilters
  appliedFilters.value = JSON.parse(JSON.stringify(filters.value));
  lastSearch.value = appliedFilters.value;
  applyFiltersEvent.value++;
  numberFiltersApplied.value = 0;
  appliedFilters.value.forEach((filter)=>{
    if(Array.isArray(filter.value)){
      if(filter.value.length>0) {
        numberFiltersApplied.value++
      }
    }
    else if(filter.value!=filter.defaultValue){
      if(filter.id!='distance' || (filter.id=='distance' && filter.value>0))numberFiltersApplied.value++
    }
    lastNumFiltersApplied.value = numberFiltersApplied.value;
  })
  // Update the distance based on filters
  const distanceFilter = filters.value.find((filter) => filter.id === 'distance');
  distance.value = distanceFilter?.value || 0;
};

const clearFiltersHandler = ()=>{
  filters.value.forEach((filter, idx) => {
    if(filter.clearable){
      filters.value[idx].value = filters.value[idx].defaultValue;
    }
  });
  applyFiltersHandler();
}

onMounted(async()=>{
  isLoggedIn.value = await Session.doesSessionExist();
  if (lastSearch.value.length>0){
    filters.value = lastSearch.value;
    applyFiltersHandler();
  }
  else{
    fetchAndCombineFilters().then((combinedFilters) => {
        filters.value = combinedFilters;
      applyFiltersHandler();
    });
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    content: _withCtx(() => [
      (!isLoggedIn.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: (_unref(isMobile))?_unref(BannerMobile):(_unref(isTablet))?_unref(BannerTablet):_unref(BannerDesktop),
              alt: "Banner promocional"
            }, null, 8, _hoisted_2),
            _createElementVNode("div", _hoisted_3, [
              _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Comprar y vender pallets", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Regístrate y pon tu anuncio gratis", -1)),
              _createVNode(_component_router_link, {
                to: { name: 'register' },
                class: "btn-primary-m btn-primary-green"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Regístrate gratis")
                ])),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(FiltersComponent, {
          filters: filters.value,
          numberFilters: numberFiltersApplied.value,
          onApplyFilters: applyFiltersHandler,
          onClearFilters: clearFiltersHandler
        }, null, 8, ["filters", "numberFilters"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, [
            _cache[3] || (_cache[3] = _createTextVNode("Mostrando resultados en un radio de ")),
            _createElementVNode("b", null, _toDisplayString(distance.value) + "Km", 1),
            _cache[4] || (_cache[4] = _createTextVNode("."))
          ])
        ]),
        _createVNode(MarketListComponent, {
          filters: filters.value,
          applyFiltersEvent: applyFiltersEvent.value
        }, null, 8, ["filters", "applyFiltersEvent"])
      ])
    ]),
    _: 1
  }))
}
}

})